import { render, staticRenderFns } from "./finish.vue?vue&type=template&id=b6db1b92&scoped=true&"
import script from "./finish.vue?vue&type=script&lang=js&"
export * from "./finish.vue?vue&type=script&lang=js&"
import style0 from "./finish.vue?vue&type=style&index=0&id=b6db1b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6db1b92",
  null
  
)

export default component.exports